import React from "react";
import { Typography } from "@material-ui/core";
import { OperatingManagerFormFields } from "Shared/types/OperatingManager";
import { FieldsGroup } from "Components/Shared/FormComponents/FieldsGroup/FieldsGroup";
import { FormField } from "Components/Shared/FormComponents/FormField/FormField";
import { usePartnerConfig } from "Hooks/usePartnerConfig";

export interface ConfirmationFormProps {
  formFields: OperatingManagerFormFields;
}

export const ConfirmationForm = ({
  formFields,
}: ConfirmationFormProps) => {
  const { associatedLocationsCount } = usePartnerConfig();
  const { locations } = formFields;
  const locationNames = locations?.length && locations.length !== associatedLocationsCount
    ? locations.map(location => location.label).join(", ")
    : "All";

  return (
    <>
      <Typography variant="h3">
        Operating Manager Information
      </Typography>
      <FieldsGroup>
        <FormField fieldName="First Name">
          <Typography>
            {formFields.firstName}
          </Typography>
        </FormField>
        <FormField fieldName="Last Name">
          <Typography>
            {formFields.lastName}
          </Typography>
        </FormField>
        <FormField fieldName="Email Address">
          <Typography>
            {formFields.email}
          </Typography>
        </FormField>
        <FormField fieldName="Phone Number">
          <Typography>
            {formFields.phoneNumber}
          </Typography>
        </FormField>
      </FieldsGroup>
      <Typography variant="h3">
        Permissions
      </Typography>
      <FieldsGroup>
        <FormField fieldName="Access Level">
          <Typography>
            {formFields.permissions?.label}
          </Typography>
        </FormField>
        {
          !!associatedLocationsCount && (
            <FormField fieldName="Location(s)">
              <Typography>
                {locationNames}
              </Typography>
            </FormField>
          )
        }
        <FormField fieldName="Monthly Budget ($)">
          <Typography>
            {formFields.budget}
          </Typography>
        </FormField>
        <FormField fieldName="Secondary Approver">
          <Typography>
            {formFields.secondaryApprovers?.map(a => a.label).join(", ")}
          </Typography>
        </FormField>
      </FieldsGroup>
    </>
  );
};

